module.exports = __webpack_public_path__ + "img/img2.5e6a6ce2.jpg";